import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";
import LetsTalkButton from "./LetsTalkButton";

const Header = () => {
  const [servicesOpen, setServicesOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const servicesRef = useRef(null);
  const closeTimeoutRef = useRef(null); //



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setServicesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="logo">
        <Link to="/" aria-label="Inypeople Home">
          <img src="/assets/logo/inypeople-logo.png" alt="Inypeople Logo" />
        </Link>
      </div>

      <button
        className={`burger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
        <ul>
          <li>
            <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
              Home
              <span className="nav-underline"></span>
            </Link>
          </li>

          <li>
            <Link to="/company" className="nav-link" onClick={() => setMenuOpen(false)}>
              Company
              <span className="nav-underline"></span>
            </Link>
          </li>

          <li
            ref={servicesRef}
            className={`dropdown services-dropdown ${servicesOpen ? "open" : ""}`}
            onMouseEnter={() => {
              if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
              }
              setServicesOpen(true);
            }}
            onMouseLeave={() => {
              closeTimeoutRef.current = setTimeout(() => {
                setServicesOpen(false);
              }, 100); // 👈 small delay (VERY IMPORTANT)
            }}
          >

            <span
              className="nav-link nav-link-no-anchor"
              onClick={() => setServicesOpen(!servicesOpen)}
            >
              Services
              <span className="nav-arrow"></span>
              <span className="nav-underline"></span>
            </span>

            <ul className="dropdown-menu">
              <li>
                <Link
                  to="/services/web-development"
                  onClick={() => {
                    setServicesOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  Web Development
                </Link>
              </li>

              <li>
                <Link
                  to="/services/application-development"
                  onClick={() => {
                    setServicesOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  Application Development
                </Link>
              </li>

              <li>
                <Link
                  to="/services/ui-ux-design"
                  onClick={() => {
                    setServicesOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  UI/UX Design
                </Link>
              </li>

              <li>
                <Link
                  to="/services/digital-marketing"
                  onClick={() => {
                    setServicesOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  Digital Marketing
                </Link>
              </li>

              <li>
                <Link
                  to="/services/data-analytics"
                  onClick={() => {
                    setServicesOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  Data & Analytics
                </Link>
              </li>

              <li>
                <Link
                  to="/services/cloud-solutions"
                  onClick={() => {
                    setServicesOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  Cloud Solutions
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/staffing" className="nav-link" onClick={() => setMenuOpen(false)}>
              Staffing
              <span className="nav-underline"></span>
            </Link>
          </li>

          <li>
            <Link to="/careers" className="nav-link" onClick={() => setMenuOpen(false)}>
              Careers
              <span className="nav-underline"></span>
            </Link>
          </li>
        </ul>

        <LetsTalkButton closeMenu={() => setMenuOpen(false)} />
      </nav>
    </header>
  );
};

export default Header;